import {init, themeParams} from "@telegram-apps/sdk"
import {setCssVar} from "quasar"

export default defineNuxtPlugin(() => {
    init()

    themeParams.mount.ifAvailable()

    if(themeParams.isMounted()) {
        let color

        if((color = themeParams.secondaryBackgroundColor())) {
            setCssVar('background', color)
            setCssVar('surface', color)
        }
    }
})